export const unit = str => str.replace(/([\.\d]+)(.*)/, '$2')
export const number = str => Number(str.replace(/([\.\d]+)(.*)/, '$1'))
export const important = str => `${str} !important`



// WEBPACK FOOTER //
// ./styles/tools/parsers.js